/**
 * Logotipo Miller. PNG vem de /public/logo-miller.png
 */
import Link from "next/link";

export function MillerMark({ className = "h-8 w-auto" }: { className?: string }) {
  // eslint-disable-next-line @next/next/no-img-element
  return <img src="/logo-miller.png" alt="Miller" className={className} draggable={false} />;
}

export function Brand({ href = "/", showWord = true }: { href?: string; showWord?: boolean }) {
  return (
    <Link href={href} className="inline-flex items-center gap-3 group select-none">
      <MillerMark className="h-9 w-auto shrink-0 transition-transform duration-200 group-hover:scale-95" />
      {showWord && (
        <span
          className="text-app-2 text-[12px] font-semibold uppercase whitespace-nowrap"
          style={{ letterSpacing: "0.34em" }}
        >
          Platform
        </span>
      )}
    </Link>
  );
}
